import script from "./toolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./toolbar.vue?vue&type=script&setup=true&lang=js"

import "./toolbar.vue?vue&type=style&index=0&id=1a7ff194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7ff194"]])

export default __exports__